// extracted by mini-css-extract-plugin
module.exports = {"container":"_2MRL3eqB-ckU5SxCquXvtS"};